import type { SupportedLanguage } from "@amtana/i18n/catalog";

import { BLOG_WORDS_EN as EN } from "./blog-words-en.ts";
import { BLOG_WORDS_ES as ES } from "./blog-words-es.ts";

/** The blog's address, with no language prefix. */
export const BLOG_PATH = "/blog";

export const BLOG_WORDS = { en: EN, es: ES } as const;

/** A language's feed: every blog page advertises it (ADR-029 point 3). */
export function feedLink(language: SupportedLanguage) {
  return {
    type: "application/rss+xml",
    title: BLOG_WORDS[language].feedTitle,
    href: `${language === "es" ? "/es" : ""}${BLOG_PATH}/rss.xml`,
  };
}

/** The blog's link for the footer's Resources column; a page in any language links its own blog. */
export function blogFooterLink(language: SupportedLanguage) {
  return { label: BLOG_WORDS[language].footerLabel, href: BLOG_PATH as string };
}
